import {Link} from "react-router-dom";
import Popover from "../global/popover";
import {useEffect, useRef} from "react";

const DashboardEntriesTable = ({headers, data}) => {
	const dashboardTable = useRef();
	const dashboardEntriesTableHeader = useRef();

	return (
		<div className="table-responsive" style={{ overflowX: "clip" }}>
			<table className="table table-striped dashboard-table" ref={dashboardTable}>
				<thead ref={dashboardEntriesTableHeader} className="dashboard-table-fixed-header">
				<tr>
					{headers.map((header, i) => (
						<th
							key={i}
							scope="col">
							{header.label}
							{header.popover?.content && (
								<Popover content={header.popover.content} trigger="hover" placement="top"/>
							)}
						</th>
					))}
				</tr>
				</thead>
				<tbody>
				{data.map((entry) => (
					<tr key={entry?.event_id}>
						<th scope="row">
							{entry?.event_id ? (
								<Link to={`/admin/events/edit/${entry.event_id}`}>
									{entry?.event_name}
								</Link>
							) : (
								<span>{entry?.event_name}</span>
							)}
						</th>
						<td>{entry?.max}</td>
						<td className={entry?.total > entry?.max ? 'highlighted' : ''}>{entry?.total}<span className="separator"></span></td>
						<td>{entry?.ho}</td>
						<td>{entry?.t}<span className="separator"></span></td>
						<td>{entry?.q}</td>
						<td>{entry?.yf}</td>
						<td>{entry?.b}<span className="separator"></span></td>
						<td>{entry?.x}</td>
						<td>{entry?.w}</td>
					</tr>
				))}
				</tbody>
			</table>
		</div>
	);
};

export default DashboardEntriesTable;
